module.exports = __webpack_public_path__ + "static/img/8-2.c9ae708.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/8-2.png
// module id = e3x9
// module chunks = 0